import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=2b108773&"
import script from "./BaseNotification.vue?vue&type=script&lang=js&"
export * from "./BaseNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b108773')) {
      api.createRecord('2b108773', component.options)
    } else {
      api.reload('2b108773', component.options)
    }
    module.hot.accept("./BaseNotification.vue?vue&type=template&id=2b108773&", function () {
      api.rerender('2b108773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/BaseNotification.vue"
export default component.exports